import { render, staticRenderFns } from "./adddealer.vue?vue&type=template&id=2dfd805b&scoped=true"
import script from "./adddealer.vue?vue&type=script&lang=js"
export * from "./adddealer.vue?vue&type=script&lang=js"
import style0 from "./adddealer.vue?vue&type=style&index=0&id=2dfd805b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd805b",
  null
  
)

export default component.exports